import React from 'react';
import './TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <div className="terms-page-inner">
        <div className="terms-header">
          <h1 className="terms-page-title">Terms of Service</h1>
          <p className="terms-updated">Last updated: August 18, 2026</p>
        </div>

        <div className="terms-body">

          <section className="terms-section">
            <h2>1. About GamePlannr</h2>
            <p>
              GamePlannr LLC ("GamePlannr," "we," "us," or "the platform") operates an online marketplace
              that connects parents ("Parents") with athlete trainers ("Trainers") for in-person youth sports
              training sessions. GamePlannr does not employ Trainers and is not responsible for the quality,
              safety, or outcome of any in-person sessions.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Eligibility</h2>
            <p>
              Trainers must be at least 14 years old. Trainers under 18 must have permission from a parent
              or legal guardian to create an account and participate as a Trainer on GamePlannr. Parents or
              guardians must be at least 18 years old. By creating a Trainer account, you confirm that you
              meet the eligibility requirements for your chosen role and, if you are under 18, that you have
              obtained permission from your parent or legal guardian.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Student-Athlete Eligibility</h2>
            <p>
              Trainers who participate in school athletics are responsible for ensuring that their use of
              GamePlannr complies with all applicable school, athletic association, and eligibility
              requirements. GamePlannr does not determine or guarantee a Trainer's athletic eligibility.
              Student-athletes subject to MHSAA rules are responsible for complying with applicable Personal
              Branding Activity requirements, including any required disclosures.
            </p>
            <p>
              GamePlannr is an independent platform and is not affiliated with, endorsed by, sponsored by,
              or operated by MHSAA, any school, school district, athletic department, or athletic association.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. The Booking Process</h2>
            <p>
              Parents may submit session requests to Trainers. Trainers may accept, decline, or suggest changes
              to the proposed session details. Once a Trainer accepts a session, the Parent must pay a
              non-refundable <strong>$4.00 booking fee</strong> via Stripe to confirm the session.
              This booking fee is charged by GamePlannr and is separate from the Trainer's session rate.
            </p>
          </section>

          <section className="terms-section terms-section-important">
            <h2>5. Payment Disclaimer — In-Person Payments</h2>
            <p>
              <strong>
                GamePlannr is not responsible for, and does not facilitate, in-person payments between
                Parents and Trainers.
              </strong>{' '}
              The Trainer's hourly or session rate is agreed upon between the Parent and Trainer and is
              collected directly by the Trainer in person (via cash, Venmo, PayPal, or another method
              agreed upon between the parties). GamePlannr has no involvement in these transactions,
              makes no guarantees regarding payment, and accepts no liability for disputes arising from
              direct payments between Users.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Booking Fee Refund Policy</h2>
            <p>
              The $4.00 booking fee paid to GamePlannr is non-refundable once a session is confirmed.
              If a session is cancelled after payment by either party, the booking fee will not be refunded.
              Disputes regarding refunds must be directed to GamePlannr support.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. User Conduct</h2>
            <p>
              All users agree to conduct themselves respectfully and professionally. GamePlannr reserves
              the right to suspend or terminate accounts that engage in abusive, fraudulent, or harmful behavior.
              You are solely responsible for any content you submit to the platform.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Safety</h2>
            <p>
              In-person sessions take place in publicly accessible locations. GamePlannr strongly recommends
              that sessions occur in public parks, recreation centers, or other well-lit, populated areas.
              Parents are responsible for ensuring the safety of their children at all times.
              GamePlannr does not conduct background checks on Trainers.
            </p>
            <p>
              Trainers are responsible for complying with applicable school, athletic-association, facility,
              and eligibility rules. Training sessions may not take place at locations where paid private
              instruction is prohibited.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Ratings and Reviews</h2>
            <p>
              Parents may leave public ratings and written reviews for Trainers after a completed session.
              Reviews must be honest and based on actual experience. GamePlannr reserves the right to remove
              reviews that violate these terms or contain inappropriate content.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              GamePlannr provides the platform "as is" and makes no warranties regarding the availability,
              accuracy, or fitness for purpose of the platform. To the maximum extent permitted by law,
              GamePlannr is not liable for any direct, indirect, incidental, or consequential damages
              arising from use of the platform or participation in in-person sessions.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Changes to These Terms</h2>
            <p>
              We may update these Terms of Service at any time. Continued use of the platform after changes
              are posted constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Contact</h2>
            <p>
              For questions about these Terms, contact GamePlannr LLC at gameplannrhq@gmail.com.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}

export default TermsPage;
